module.exports = __webpack_public_path__ + "static/img/c_img_4.36604e22.png";